export default "__VITE_ASSET__68b5032e__"